import AppListingPage from "@/components/getListed/appListing/AppListingPage"

type Props = {}

const index = (_props: Props) => {
  return <AppListingPage />
}

export default index
